import { render, staticRenderFns } from "./OpenPdf.vue?vue&type=template&id=6f8b3f76&"
import script from "./OpenPdf.vue?vue&type=script&lang=js&"
export * from "./OpenPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports